'use strict';

let $ = require('jquery');

class ProductCategoryTransition {

    constructor() {

        App.Globals.$window.on('load site:ajax-ready', () => {

            this.transitionEvent();
        });
    };

    transitionEvent() {

        let $anchorSection = $('[data-anchor-section]');
        let $animationElement = $('[data-animation-element]');
        let contactInfoHeight = $animationElement.height();
        let checkResolution = App.Globals.$window.width();

        $anchorSection.hover(function () {

                if (checkResolution >= 1024) {

                    let $this = $(this);
                    let $contactInfo = $this.find($animationElement);

                    // GSAP doesn't animate to height: auto. So first, temporarily set the height
                    // to 'auto'. Immediately start a Tween that animates from 'height: 0'.
                    TweenLite.set($contactInfo, {height: 'auto'});
                    TweenLite.from($contactInfo, 0.15, {height: contactInfoHeight});
                }
            },


            function () {

                let $this = $(this);

                if (checkResolution >= 1024) {

                    TweenLite.to($this.find($animationElement), 0.15, {height: contactInfoHeight});
                }
            }
        );
    }
}

module.exports = ProductCategoryTransition;
